export function LaserPermitApplicationFactory() {
    return function LaserPermitApplication() {
        this.name = null;
        this.id = null;
    }
}
